module.exports = __webpack_public_path__ + "img/10.f4e4451d.jpg";